module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.loggedIn) { 
    ; __append(" <div class=\"dropdown acc-info\"> <div class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"> <a href=\"#\">")
    ; __append(escapeFn( locals.email ))
    ; __append("</a> <div class=\"down-arrow pull-right\"></div> </div> <ul class=\"dropdown-menu col-sm-12\"> ")
    ;  locals.collection.forEach(function(item) { 
    ; __append(" <li><a href=\"/account/")
    ; __append(escapeFn( item.get('route') ))
    ; __append("\">")
    ; __append(escapeFn( item.get('readable') ))
    ; __append("</a></li> ")
    ;  }); 
    ; __append(" <li><a href=\"#\" id=\"signout\">Sign Out</a></li> </ul> </div> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/user_nav.ejs
// module id = 919
// module chunks = 1